import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  children: {
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer')
  },

  menu: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    border: '1px solid #E6EAEC',
    borderRadius: '6px',
    boxSizing: 'border-box',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.04)',
    minWidth: '10rem',
    padding: '10px 13px',
    background: '#FFFFFF',
    maxHeight: 350,
    overflow: 'auto',
    justifyContent: 'initial',

    '& > :not(:last-child)': {
      marginBottom: '16px'
    },
    '@media (max-width: 575px)': {
      maxHeight: 250
    }
  },

  search: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },

  input: {
    border: 'none',
    outline: 'none',
    color: '#323436'
  },

  close: {
    color: '#323436',
    fontSize: theme.size.base,
    cursor: 'pointer'
  },

  buttonIcon: {
    marginRight: '0.5rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  },

  radioGroup: {
    '& .label:not(:last-child)': {
      marginBottom: '-6px'
    },

    '& .MuiFormControlLabel-label': {
      fontSize: theme.size.sm,
      color: '#323436'
    }
  },

  selectedRadio: {
    '& .MuiFormControlLabel-label': {}
  },

  disabledRadio: {
    '& .MuiFormControlLabel-label': {
      color: '#B0B0B0'
    }
  },

  // hiding radials for user list
  radioGroupHide: {
    search: {
      marginBottom: '0'
    },

    '& .MuiRadio-root': {
      display: 'none'
    },

    '& .label:first-child': {
      marginTop: '0.5rem'
    },

    '& .label:last-child': {
      marginBottom: '0.5rem'
    },

    '& .label': {
      margin: '1.5rem 0.5rem'
    }
  },

  loading: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '0.75rem',
    width: '100%'
  }
}))

export default useStyles
